import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	verticalChartLine: {
		display: 'block',
		width: '2px',
		minHeight: '20px',
		marginBottom: token('space.100'),
		borderRadius: token('radius.full'),
		backgroundColor: token('color.background.neutral.hovered'),
	},
	avatarItemContainer: {
		maxWidth: '210px',
		width: '100%',
	},
	avatarItemText: {
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
	},
	chartCard: {
		fontWeight: token('font.weight.regular'),
		display: 'flex',
		flexWrap: 'nowrap',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '285px',
		paddingRight: token('space.200'),
		marginBottom: token('space.100'),
		borderRadius: token('radius.medium'),
		backgroundColor: token('color.background.neutral'),
	},
	chartCardSelected: {
		backgroundColor: token('elevation.surface'),
		borderStyle: 'solid',
		borderColor: token('color.border.focused'),
		borderWidth: token('border.width'),
	},
	reportsList: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
		columnGap: token('space.200'),
		justifyItems: 'center',
		width: '100%',
	},
});

export function VerticalChartLine() {
	return <Box xcss={styles.verticalChartLine} />;
}

export function AvatarItemContainer({ children }: { children: React.ReactNode }) {
	return <Box xcss={styles.avatarItemContainer}>{children}</Box>;
}

export function AvatarItemText({ children }: { children: React.ReactNode }) {
	return <Box xcss={styles.avatarItemText}>{children}</Box>;
}

export function ChartCard({
	children,
	selected = false,
	testId,
}: {
	children: React.ReactNode;
	selected?: boolean;
	testId?: string;
}) {
	return (
		<Box xcss={cx(styles.chartCard, selected && styles.chartCardSelected)} testId={testId}>
			{children}
		</Box>
	);
}

export function ReportsList({ children, testId }: { children: React.ReactNode; testId?: string }) {
	return (
		<Box xcss={styles.reportsList} testId={testId}>
			{children}
		</Box>
	);
}
